// 生成 RFC4122 v4 UUID。优先用 crypto.randomUUID（仅安全上下文 / localhost 可用），
// 回落到 crypto.getRandomValues（非安全上下文如明文 HTTP + 局域网 IP 下仍可用，且仍是强随机）。
// 用于前端临时态 id（评论草稿 / 上传任务等），不依赖密码学保证亦无妨。
export const randomId = (): string => {
  const cryptoObj = globalThis.crypto
  if (typeof cryptoObj?.randomUUID === 'function') {
    return cryptoObj.randomUUID()
  }

  const bytes = new Uint8Array(16)
  cryptoObj.getRandomValues(bytes)
  // 按 RFC4122 v4 置位：version 高半字节为 4，variant 高两位为 10。
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80

  const hex = Array.from(
    bytes,
    b =>
      b
        .toString(16)
        .padStart(2, '0'),
  )
  return [
    hex
      .slice(0, 4)
      .join(''),
    hex
      .slice(4, 6)
      .join(''),
    hex
      .slice(6, 8)
      .join(''),
    hex
      .slice(8, 10)
      .join(''),
    hex
      .slice(10, 16)
      .join(''),
  ].join('-')
}
